import { Select } from 'antd';
import en from '../assets/languages/enIcon.svg';
import ro from '../assets/languages/roIcon.svg';
import '../styles/LanguageComponent.css';

const LanguageComponent = ({ currentLanguage = 'en', onLanguageChange }) => {

    return (
        <div style={{ marginLeft: 'auto' }}>
            <Select
                className='neon-language-select'
                value={currentLanguage} 
                onChange={onLanguageChange} 
                style={{ width: 80 }}
            >
                <Select.Option value="en"><img src={en} alt="English" style={{ width: '40px', height: '30px', marginRight: '8px', boxShadow: '0 0 0 rgba(0, 0, 0)' }} /></Select.Option>
                <Select.Option value="ro"><img src={ro} alt="Romana" style={{ width: '40px', height: '30px', marginRight: '8px' }} /></Select.Option>
            </Select>
        </div>
    );
}

export default LanguageComponent;
